
import { useEffect, useRef, useState } from "react";

interface RedirectCountdownProps {
  seconds: number;
}

export const RedirectCountdown = ({ seconds }: RedirectCountdownProps) => {
  const [countdown, setCountdown] = useState<number>(seconds);
  const countdownRef = useRef<number | null>(null);
  const unmountedRef = useRef(false);

  useEffect(() => {
    // Start countdown
    countdownRef.current = window.setInterval(() => {
      if (unmountedRef.current) return;
      
      setCountdown(prev => {
        if (prev <= 1) {
          if (countdownRef.current) {
            window.clearInterval(countdownRef.current);
            countdownRef.current = null;
          }
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      unmountedRef.current = true;
      if (countdownRef.current) {
        window.clearInterval(countdownRef.current);
        countdownRef.current = null;
      }
    };
  }, []);

  if (countdown === 0) return null;

  return (
    <p className="text-sm text-gray-600 mb-4">
      Redirecting to dashboard in {countdown} seconds...
    </p>
  );
};
